export const Tag = ({ children, className = '' }) => (
  <div
    className={`${className} inline-block rounded-full bg-lighterGray px-8 py-4 text-8 uppercase leading-100`}
  >
    {children}
  </div>
)
